// extracted by mini-css-extract-plugin
export default {"call":"Call_call__1P7+q"};